
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/reinsurance",
      function () {
        return require("private-next-pages/solutions/reinsurance/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/reinsurance"])
      });
    }
  